import { isNil } from 'lodash/fp';
import type { SnowflakeTableFqn, SnowflakeSchemaFqn } from 'app/lib/types/server';
import { stripQuotes } from 'app/lib/utils';

export const fqnRegExp = /\.(?=(?:[^"]*"[^"]*")*[^"]*$)/;
export const splitFqn = (fqn: string | null): null | SnowflakeTableFqn | SnowflakeSchemaFqn => {
    if (isNil(fqn)) {
        return null;
    }
    const [database, schema, table] = fqn.split(fqnRegExp);

    if (database && schema && table) {
        return {
            database: stripQuotes(database),
            schema: stripQuotes(schema),
            table: stripQuotes(table)
        };
    }

    if (database && schema) {
        return {
            database: stripQuotes(database),
            schema: stripQuotes(schema)
        };
    }

    return null;
};
